// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tq-0";